const TYPE = {
  QuestionAndAnswer: 'QuestionAndAnswer',
  OnTheGroundGallery: 'OnTheGroundGallery',
  OnTheGroundVideo: 'OnTheGroundVideo',
  //
  OntheGroundPhoto: 'OntheGroundPhoto',
  Article: 'Article',
  Forum: 'Forum',

  Story: 'Story',
  Event: 'Event',
  //
  YouTubeVideo: 'YouTubeVideo',
  TravelProfile: 'TravelProfile',
  TravelProfileAddMatch: 'TravelProfileAddMatch',
  DateFinder: 'DateFinder',
  DateFinderAdd: 'DateFinderAdd',
  CompetitionTestimonialAdd: 'CompetitionTestimonialAdd',
  Testimonial: 'Testimonial',
  ArticleAdd: 'ArticleAdd',

  UserProfileUpdated: 'UserProfileUpdated',
  SexSecret: 'SexSecret',
  CommentLike: 'CommentLike', // use for all
  ReplyLike: 'ReplyLike', // use for all
  UserValidation: 'UserValidation',
  ClubReview: 'ClubReview',
  UserValidationList: 'UserValidationList',
  EventInterestAdd: 'EventInterestAdd',
  ClubPost: 'ClubPost',
  ClubAlbum: 'ClubAlbum',
  ClubMedia: 'ClubMedia',
  ClubPhoto: 'ClubPhoto',
  ClubVideo: 'ClubVideo',
  ClubReviewList: 'ClubReviewList',
  ClubValidation: 'ClubValidation',
  Club: 'Club',
  ClubJoin: 'ClubJoin',
  // Type have actor properties show header
  // icon name
  LIKE: {
    OntheGroundGalleryLike: 'OntheGroundGalleryLike',
    OntheGroundVideoLike: 'OntheGroundVideoLike',
    OntheGroundPhotoLike: 'OntheGroundPhotoLike',
    ArticleLike: 'ArticleLike',
    StoryLike: 'StoryLike',
    ForumLike: 'ForumLike',
  },
  COMMENT: {
    OntheGroundGalleryComment: 'OntheGroundGalleryComment',
    OntheGroundVideoComment: 'OntheGroundVideoComment',
    OntheGroundPhotoComment: 'OntheGroundPhotoComment',
    ArticleComment: 'ArticleComment',
    ForumReply: 'ForumReply',
    StoryComment: 'StoryComment',
    EventComment: 'EventComment',
  },
  COMMENT_REPLY: {
    OntheGroundGalleryCommentReply: 'OntheGroundGalleryCommentReply',
    OntheGroundVideoCommentReply: 'OntheGroundVideoCommentReply',
    OntheGroundPhotoCommentReply: 'OntheGroundPhotoCommentReply',
    ArticleCommentReply: 'ArticleCommentReply',
    StoryCommentReply: 'StoryCommentReply',
    EventCommentReply: 'EventCommentReply',
  },
  REPLY_LIKE: {
    OTGGallery_ReplyLike: 'ReplyLike',
    OTGVideo_ReplyLike: 'ReplyLike',
    OTGPhoto_ReplyLike: 'ReplyLike',
    Article_ReplyLike: 'ReplyLike',
    Story_ReplyLike: 'ReplyLike',
    Event_ReplyLike: 'ReplyLike',
  },
  COMMNET_LIKE: {
    OTGGallery_CommentLike: 'CommentLike',
    OTGVideo_CommentLike: 'CommentLike',
    OTGPhoto_CommentLike: 'CommentLike',
    Article_CommentLike: 'CommentLike',
    Story_CommentLike: 'CommentLike',
    Event_CommentLike: 'CommentLike',
  },
  UPLOADED: {
    UserPhotoUploaded: 'UserPhotoUploaded',
  },
  ADDED: {
    ForumTopicAdded: 'ForumTopicAdded',
    EroticStoriesAdd: 'EroticStoriesAdd',
    StoryAdded: 'StoryAdded',
    EventAdd: 'EventAdd',
  },
  OTG_NAME: {
    OTG_Gallery: 'OTG_Gallery',
    OTG_Photos: 'OTG_Photos',
    OTG_Photo: 'OTG_Photo',
    OTG_Video: 'OTG_Video',
    OTG_Article: 'OTG_Article',
    OTG_Forum: 'OTG_Forum',
    OTG_Story: 'OTG_Story',
    OTG_Event: 'OTG_Event',
    OTG_Travel: 'OTG_Travel',
    OTG_DateFinder: 'OTG_DateFinder',
    OTG_Testimonial: 'OTG_Testimonial',
    OTG_SexSecret: 'OTG_SexSecret',
    OTG_ProfileUpdate: 'OTG_ProfileUpdate',
    OTG_Validation: 'OTG_Validation',
    OTG_Review: 'OTG_Review',
    OTG_GroupPost: 'OTG_GroupPost',
    OTG_ClubReviewList: 'OTG_ClubReviewList',
    OTG_GroupAlbum: 'OTG_GroupAlbum',
    OTG_ClubJoin: 'OTG_ClubJoin',
  },
  GLOBE: {
    EroticStoriesAdd: 'EroticStoriesAdd',
    ForumActivity: 'ForumActivity',
    EventUpdated: 'EventUpdated',
    ArticleAdd: 'ArticleAdd',
    Testimonial: 'Testimonial',
    CompetitionTestimonialAdd: 'CompetitionTestimonialAdd',
    UserValidations: 'UserValidation',
  },
};
const ValidNewFeedType = [
  'QuestionAndAnswer',
  'OnTheGroundGallery',
  'OnTheGroundVideo',
  'ClubReviewList',
  //
  'OntheGroundPhoto',
  'Article',
  'Forum',

  'Story',
  'Event',
  //
  'YouTubeVideo',
  'TravelProfile',
  'TravelProfileAddMatch',
  'DateFinder',
  'DateFinderAdd',
  'CompetitionTestimonialAdd',
  'Testimonial',
  'ArticleAdd',

  'UserProfileUpdated',
  'SexSecret',
  'CommentLike', // use for all
  'ReplyLike', // use for all
  'UserValidation',
  'ClubReview',
  'UserValidationList',
  'EventInterestAdd',
  'OntheGroundGalleryLike',
  'OntheGroundVideoLike',
  'OntheGroundPhotoLike',
  'ArticleLike',
  'StoryLike',
  'ForumLike',
  'OntheGroundGalleryComment',
  'OntheGroundVideoComment',
  'OntheGroundPhotoComment',
  'ArticleComment',
  'ForumReply',
  'StoryComment',
  'EventComment',
  'OntheGroundGalleryCommentReply',
  'OntheGroundVideoCommentReply',
  'OntheGroundPhotoCommentReply',
  'ArticleCommentReply',
  'StoryCommentReply',
  'EventCommentReply',
  'ReplyLike',
  'ReplyLike',
  'ReplyLike',
  'ReplyLike',
  'ReplyLike',
  'ReplyLike',
  'CommentLike',
  'CommentLike',
  'CommentLike',
  'CommentLike',
  'CommentLike',
  'CommentLike',
  'UserPhotoUploaded',
  'ForumTopicAdded',
  'EroticStoriesAdd',
  'StoryAdded',
  'EventAdd',
  'EroticStoriesAdd',
  'ForumActivity',
  'EventUpdated',
  'ArticleAdd',
  'Testimonial',
  'CompetitionTestimonialAdd',
  'UserValidation',
  'ClubPost',
  'ClubAlbum',
  'Club',
  'ClubJoin',
];
export default TYPE;
export { ValidNewFeedType };
